var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhiteTint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2915 46.8034L41.1845 46.8574C40.3537 47.2176 39.3918 46.9962 38.8407 46.3181L29.4361 34.7747C28.9476 34.1758 28.1302 33.9274 27.3594 34.1437L12.5092 38.3181C11.6376 38.5673 10.7177 38.2195 10.2689 37.471C9.82011 36.7226 9.95502 35.7613 10.5975 35.13L34.4329 11.6461C34.9539 11.0575 35.7763 10.8148 36.5285 11.0277C37.2808 11.2407 37.8203 11.8689 37.9034 12.6285L42.4761 44.7433C42.5954 45.5983 42.111 46.4406 41.2915 46.8034Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0071 20.6034L8.93796 31.8392",
    stroke: "white",
    strokeWidth: 2.01121,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.306 13.0189L11.3829 23.9444",
    stroke: "white",
    strokeWidth: 2.01121,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhiteTint);
export default __webpack_public_path__ + "static/media/logo-white-tint.eaa09b286ebd0f566a2fbc41c3f58788.svg";
export { ForwardRef as ReactComponent };